/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BeautyCosmeticsPerfumeIcon16Solid = forwardRef('BeautyCosmeticsPerfumeIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 .75A.75.75 0 0 1 5.75 0h4.5a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.75.75H10V5h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V3.5h-.25A.75.75 0 0 1 5 2.75v-2Zm3 11.542c2.024 0 3.665-1.026 3.665-2.292 0-1.266-1.64-2.292-3.665-2.292-2.024 0-3.665 1.026-3.665 2.292 0 1.266 1.64 2.292 3.665 2.292Z" })));
});
